// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"996b994a","183":"57f44695","212":"53132451","221":"4bce42f5","240":"04308cf1","382":"d6890d8b","388":"801818b9","453":"dd9dfc59","672":"15171414","811":"a382a95e"}[chunkId] + ".chunk.js";
};